import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Recipient } from './recipient'

export class RecipientsRepository extends BaseRepository<Recipient> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.brokerApiUrl + '/' + 'recipients', token, cache)
    }

    async getStatus() {
        const url = this.config.brokerApiUrl + '/recipients/status?token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
    async retry(recipientId: string) {
        const url = this.config.brokerApiUrl + '/recipients/' + recipientId + '/retry?token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.post(url, null)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async clearOutbox(service: string, serviceToken: string) {
        const url = this.config.brokerApiUrl + '/recipients/clear?service=' + service + '&token=' + serviceToken
        const { json, statusCode, message } = await this.request.post(url, null)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
